import { render } from "./ParticlesView.vue?vue&type=template&id=8e3f64ce&ts=true"
import script from "./ParticlesView.vue?vue&type=script&lang=ts"
export * from "./ParticlesView.vue?vue&type=script&lang=ts"

import "./ParticlesView.vue?vue&type=style&index=0&id=8e3f64ce&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__